import React from 'react'
import { useAppSelector } from '../../../../../../../../../../app/hooks'
import { InitState } from '../../../../../../../../../../redux/reducers/root/initialState'
import { AttachmentDataWithRequiredAttachment, AttachmentType } from '../../../../../../../../../../@types/types'
import { PictureCarousel } from './PictureCarousel'
import { useMultimediaDetailsModalContext } from '../../../../multimediaDetailsModalContext/multimediaModalsContext'
import { createAndTriggerPluploadFileInput } from '../../../utils/fileUploadUtils'
import styles from './MobileMultimediaPreview.module.css'

interface MobileMultimediaPreviewProps {
  dropzoneId: string
  pluploadRef?: React.Ref<HTMLDivElement>
}

export const WebViewMultimediaPreview: React.FC<MobileMultimediaPreviewProps> = ({ dropzoneId, pluploadRef }) => {
  const attachments = useAppSelector((state: InitState) => state.multimediaFeature.attachments || [])
  const { openModalForEditClick } = useMultimediaDetailsModalContext()

  const pictureAttachments = attachments.filter(
    (attachment) => attachment.attachmentType === AttachmentType.PICTURE && attachment.attachment?.url
  ) as AttachmentDataWithRequiredAttachment[]

  if (pictureAttachments.length === 0) {
    return null
  }

  const handleEditClick = (attachment: AttachmentDataWithRequiredAttachment) => {
    // Find the index of the clicked attachment in the full attachments array
    const attachmentIndex = attachments.findIndex((att) => att === attachment)
    openModalForEditClick(attachmentIndex)
  }

  const handleAddClick = () => {
    createAndTriggerPluploadFileInput()
  }

  return (
    <>
      <div ref={pluploadRef} style={{ display: 'none' }} />
      <div className={`relative w-full ${styles.previewContainer}`}>
        <PictureCarousel
          attachments={pictureAttachments}
          onEditClick={handleEditClick}
          onAddClick={handleAddClick}
          dropzoneId={dropzoneId}
        />
      </div>
    </>
  )
}
